const STORAGE_PREFIX = 'minecards:friend-created-counts'

const normalizeCount = (value) => {
    const count = Number(value)
    return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0
}

const isSnapshot = (value) =>
    value &&
    typeof value === 'object' &&
    Number.isFinite(Number(value.count)) &&
    typeof value.observedOn === 'string'

export const getCreatedCountStorageKey = (viewerId) =>
    viewerId === undefined || viewerId === null
        ? null
        : `${STORAGE_PREFIX}:${viewerId}`

export const getLocalDateKey = (date = new Date()) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export const readCreatedCountSnapshots = (storage, storageKey) => {
    if (!storage || !storageKey) return {}

    try {
        const parsed = JSON.parse(storage.getItem(storageKey) || '{}')
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return {}
        }

        return Object.fromEntries(
            Object.entries(parsed).filter(([, value]) => isSnapshot(value))
        )
    } catch {
        return {}
    }
}

export const writeCreatedCountSnapshots = (storage, storageKey, snapshots) => {
    if (!storage || !storageKey) return

    try {
        storage.setItem(storageKey, JSON.stringify(snapshots))
    } catch {
        // The indicator is optional when browser storage is unavailable.
    }
}

export const reconcileCreatedCountSnapshots = (
    snapshots,
    profiles,
    observedOn
) => {
    const next = { ...snapshots }

    profiles.forEach(({ id, createdCount }) => {
        if (id === undefined || id === null) return

        const key = String(id)
        const count = normalizeCount(createdCount)
        const previous = isSnapshot(next[key]) ? next[key] : null

        if (!previous) {
            next[key] = { count, observedOn, pending: false }
            return
        }

        if (previous.pending && count > normalizeCount(previous.count)) {
            return
        }

        if (
            previous.observedOn !== observedOn &&
            count > normalizeCount(previous.count)
        ) {
            next[key] = { ...previous, pending: true }
            return
        }

        next[key] = { count, observedOn, pending: false }
    })

    return next
}

export const acknowledgeCreatedCount = (
    snapshots,
    profileId,
    createdCount,
    observedOn
) => ({
    ...snapshots,
    [String(profileId)]: {
        count: normalizeCount(createdCount),
        observedOn,
        pending: false,
    },
})

export const getPendingCreatedCountIds = (snapshots) =>
    new Set(
        Object.entries(snapshots)
            .filter(([, snapshot]) => snapshot.pending)
            .map(([profileId]) => profileId)
    )
